import { Box, Button, Card, CardBody, CardFooter, CardHeader, Image, Paragraph, Text } from "grommet"
import { formattedPrice } from "../../utils/priceUtils"
import { Trans, useTranslation } from "react-i18next"

const donateVariantTypes = {
    AUCTION: 'AUCTION',
    ROULETTE: 'ROULETTE',
    MEMES: 'MEMES'
}

const donateVariantCardPreviewImage = {
    AUCTION: `${process.env.REACT_APP_CDN_BASE_URL}/homepage/auc_banner.webp`,
    ROULETTE: `${process.env.REACT_APP_CDN_BASE_URL}/homepage/roulette_banner.webp`,
    MEMES: `${process.env.REACT_APP_CDN_BASE_URL}/homepage/memes_banner.webp`
}

export const DonateVariantCardPreview = ({ data, onWish }) => {

    const { t } = useTranslation('donations', { useSuspense: false });

    return (
        <Card style={{ maxWidth: '500px' }}>
            <CardHeader pad={'none'}>
                <Box>
                    <Image src={donateVariantCardPreviewImage[data?.type]} />
                </Box>
            </CardHeader>
            <CardBody gap="small">
                <Box direction="row">
                    <Text size="medium" weight={'bolder'} truncate="tip" >{data?.title}</Text>
                </Box>
                <Paragraph size="small" margin={'none'} style={{ minHeight: '100px' }}>{data?.description}</Paragraph>
            </CardBody>
            <CardFooter direction="row" justify="between" align="center" pad={'medium'}>
                <Text weight={'bold'}><PriceTitle data={data} /></Text>
                <Button primary label={t('wishBtn')} onClick={() => onWish(data)} />
            </CardFooter>
        </Card>
    )
}


const PriceTitle = ({ data }) => {

    if (data?.type ===  donateVariantTypes.AUCTION) {
        return (<Trans i18nKey="donations:fromPrice" values={{ price: formattedPrice(data?.cost) }} />);
    } else if (data?.type === donateVariantTypes.ROULETTE) {
        return (<Trans i18nKey="donations:spinCost" values={{ price: formattedPrice(data?.cost) }} />);
    } else if (data?.type === donateVariantTypes.MEMES) {
        return (<Trans i18nKey="donations:fromPrice" values={{ price: formattedPrice(data?.price) }} />);
    }
    return (`${formattedPrice(data?.cost)} UAH`);
}